<div *ngIf="message.detail.type === 'app-update'" class="custom-toast-container">
    <div class="flex align-items-center">
        <i class="pi pi-sync text-lg"></i>
        <div class="ml-3">
            <h6>{{message.summary}}</h6>
            <p>Une nouvelle version de l'application est disponible. Rafraîchissez la page pour l'utiliser.</p>
        </div>
    </div>
    <div class="flex justify-content-end gap-2 mt-2">
        <p-button icon="pi pi-refresh" severity="primary" label="Rafraîchir" size="small"
            (onClick)="applyUpdate()"></p-button>
        <p-button icon="pi pi-times" severity="secondary" label="Plus tard" size="small"
            (onClick)="closeUpload()"></p-button>
    </div>
</div>
<div *ngIf="message.detail.type !== 'upload' && message.detail.type !== 'download' && message.detail.type !== 'app-update'" class="custom-toast-container">
    <div class="flex align-items-center">
      <i class="pi" [ngClass]="getIconClass(message.severity)"></i>
      <div class="ml-3">
        <h6>{{message.summary}}</h6>
        <p>{{message.detail}}</p>
      </div>
    </div>
    <div class="flex justify-content-end">
        <p-button *ngIf="getViewUrl() as viewUrl" icon="pi pi-external-link" severity="secondary" label="Ouvrir" size="small" (onClick)="openUrl(viewUrl)"></p-button>
    </div>
</div>
<div *ngIf="message.detail.type === 'upload'">
    <div *ngIf="success() === null" class="flex flex-column gap-2">
        <div class="flex items-center">
            <i class="pi pi-upload mr-2"></i>
            <h6 class="m-0">{{message.summary}}</h6>

        </div>
        <div class="flex flex-column gap-1 mt-4">
            <div class="flex justify-content-between">
                <span class="text-sm">{{message.detail.upload.name}}</span>
                <span class="text-sm">{{progress()}}%</span>
            </div>
            <p-progressBar [value]="progress()" 
                          [showValue]="false"
                          [mode]="progress() === 100 ? 'indeterminate' : 'determinate'">
            </p-progressBar>
        </div>
    </div>
    <div *ngIf="success() === false" class="flex flex-column gap-2">
        <div class="flex items-center">
            <i class="pi pi-upload mr-2"></i>
            <h6 class="m-0">{{message.summary}}</h6>
        </div>
        <p>{{message.detail.upload.name}} a échoué</p>
        <div class="flex justify-content-end mt-2">
            <p-button icon="pi pi-refresh" 
                     label="Réessayer" 
                     severity="secondary" 
                     size="small"
                     (onClick)="message.detail.upload.onRetry()">
            </p-button>
        </div>
    </div>
    <div *ngIf="success() === true" class="flex flex-column gap-2">
        <div class="flex items-center">
            <i class="pi pi-check mr-2"></i>
            <h6 class="m-0">{{message.summary}}</h6>
        </div>
        <p>{{message.detail.upload.name}} a été téléversé avec succès</p>
        <div class="flex justify-content-end gap-2 mt-2">
            <p-button icon="pi pi-refresh"
                     label="Actualiser"
                     severity="secondary"
                     size="small"
                     (onClick)="reload()">
            </p-button>
            <p-button icon="pi pi-check" 
                     label="Fermer" 
                     severity="secondary" 
                     size="small"
                     (onClick)="closeUpload()">
            </p-button>
        </div>
    </div>
</div>


